import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: "1",
        margin: "2px 2px 2px 8px",
        padding: "6px 0px 6px 0px",
        textAlign: "start",
    },
    root_tight: {
        margin: "2px 2px 0px 8px",
        padding: "6px 0px 4px 0px",
        maxWidth: "100%",
        maxWidth: "-webkit-fill-available",
        maxWidth: "-moz-available",
        maxWidth: "fill-available",
    },
    root_extra_tight: {
        margin: "0px 2px 0px 8px",
        padding: "2px 0px 0px 0px",
        maxWidth: "100%",
        maxWidth: "-webkit-fill-available",
        maxWidth: "-moz-available",
        maxWidth: "fill-available",
    },
    label: {
        flex: "1",
        font: "14px " + theme.typography.fontFamily,
        fontWeight: theme.brand.FIELDERS ? "700" : "200",
        color: Palette.Control.DarkGrey,
        padding: "6px 0px",
        textAlign: "start",
    },
    label_tight: {
        font: "13px " + theme.typography.fontFamily,
        fontWeight: theme.brand.FIELDERS ? "700" : "200",
        padding: "6px 0px 4px 0px",
        maxWidth: "100%",
        maxWidth: "-webkit-fill-available",
        maxWidth: "-moz-available",
        maxWidth: "fill-available",
    },
    label_extra_tight: {
        font: "12px " + theme.typography.fontFamily,
        fontWeight: theme.brand.FIELDERS ? "700" : "200",
        padding: "2px 0px 0px 0px",
        maxWidth: "100%",
        maxWidth: "-webkit-fill-available",
        maxWidth: "-moz-available",
        maxWidth: "fill-available",
    },
    subtitle: {
        flex: "1",
        font: "13px " + theme.typography.fontFamily,
        fontWeight: theme.brand.FIELDERS ? "400" : "200",
        color: "#6B8799",
        textAlign: "end",
        padding: "4px 0px",
    },
    helperText: {
        flex: "1",
        font: "13px " + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        textAlign: "start",
        padding: "4px 0px",
    },
    errorText: {
        flex: "1",
        font: "13px " + theme.typography.fontFamily,
        color: Palette.Control.Error,
        textAlign: "start",
        padding: "0px 0px",
        verticalAlign: "text-top",
        display: "flex",
        alignItems: "center",
    },
    input: {
        padding: "2px",
        font: "16px " + theme.typography.fontFamily,
        fontWeight: theme.brand.FIELDERS ? "400" : "200",
        padding: "10px 8px",
    },
    input_tight: {
        padding: "4px 0px 4px 8px",
    },
    textField: {
        borderRadius: "0px",
        background: "white",
        border: "1px solid #6B8799",
        "&:before": {
            border: "none",
        },
    },
    notchedOutline: {
        "&:focus": {
            borderWidth: "1px",
            borderColor: "#002D62 !important",
        },
    },
    disabled: {
        backgroundColor: Palette.Control.LightGrey,
    },
    endAdornment: {
        paddingRight: "6px",
        font: "16px " + theme.typography.fontFamily,
        fontWeight: theme.brand.FIELDERS ? "400" : "200",
        color: "#6B8799",
    },
}));

export default function BSL_ControlContainer(props) {
    const classes = useStyles();

    return (
        <div
            className={
                classes.root +
                (props.tight ? " " + classes.root_tight : "") +
                (props.extratight ? " " + classes.root_extra_tight : "")
            }
            style={props.style ? props.style : {}}
        >
            {(props.label !== undefined || props.optional) && (
                <div style={{ display: "flex", paddingBottom: props.tight ? "0px" : "4px", width: "95%" }}>
                    <div
                        className={
                            classes.label +
                            (props.tight ? " " + classes.label_tight : "") +
                            (props.extratight ? " " + classes.label_extra_tight : "")
                        }
                    >
                        {props.label}
                    </div>
                    {props.optional && (
                        <div
                            className={
                                classes.subtitle +
                                (props.tight ? " " + classes.label_tight : "") +
                                (props.extratight ? " " + classes.label_extra_tight : "")
                            }
                        >
                            Optional
                        </div>
                    )}
                </div>
            )}
            {props.children}
            {(props.helperText || props.error) && (
                <div style={{ display: "flex", padding: "8px 0px 0px 0px", flexDirection: "column" }}>
                    {props.error && (
                        <div className={classes.errorText}>
                            <ErrorOutlineIcon style={{ width: "16px", height: "16px", marginRight: "8px" }} />{" "}
                            {props.error}
                        </div>
                    )}
                    {props.helperText && (
                        <div className={classes.helperText} style={props.helperTextStyle ? props.helperTextStyle : {}}>
                            {typeof props.helperText === "function" ? props.helperText() : props.helperText}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}